import 'bootstrap';
import $ from 'jquery';
import {showToastNotify, checkSymbols, TOASTR_ERROR} from './helpers'

const ERROR_INPUT_DATA = 'error-input-group';
const NON_VISIBLE = 'd-none';

const partnerWithdraws = () => {
    const usdAmount = $('#partner-withdraw-usd-amount');
    const btcAddress = $('#partner-withdraw-btc-addr');
    const usdAmountValue = usdAmount.val();
    const btcAddressValue = btcAddress.val();
    const maxWithdrawAmount = parseFloat($('#partner-max-withdraw-amount').text());
    const btcAddrError = $('#partner-withdraw-btc-addr-error');
    const btcAmountError = $('#partner-withdraw-usd-amount-error');
    const btcAmountMinError = $('#partner-withdraw-usd-amount-min-error');

    if (!usdAmountValue || !btcAddressValue || (usdAmountValue > maxWithdrawAmount) || usdAmountValue < 10) {
        if (!usdAmountValue) {
            usdAmount.addClass(ERROR_INPUT_DATA);
        }
        if (!btcAddressValue) {
            btcAddress.addClass(ERROR_INPUT_DATA);
            btcAddrError.removeClass(NON_VISIBLE)
        }
        if (usdAmountValue > maxWithdrawAmount) {
            usdAmount.addClass(ERROR_INPUT_DATA);
            btcAmountError.removeClass(NON_VISIBLE)
        }
        if (usdAmountValue < 10) {
            usdAmount.addClass(ERROR_INPUT_DATA);
            btcAmountMinError.removeClass(NON_VISIBLE)
        }
    } else {
        changePartnerWithdrawData();
        $('#partner-confirm-withdraw-btc-address').text(btcAddressValue);
        $('#partner-confirm-withdraw-usd-amount').text(usdAmountValue);
        $('#partnerWithdraw').modal('hide');
        $('#partnerConfirmWithdrawQuery').modal('show');
    }
}

const confirmPartnerWithdraw = () => {
    sendPartnerWithdrawQuery();
}

export const sendPartnerWithdrawQuery = () => {
    const btcAddr = $('#partner-confirm-withdraw-btc-address').text();
    const usdAmount = $('#partner-confirm-withdraw-usd-amount').text();
    $.ajax({
        type: 'POST',
        url: '/partner-withdraw',
        data: {
            'btc_addr': btcAddr,
            'usd_amount': usdAmount,
        },
        success: function (result) {
            if (result) {
                if (!result.error) {
                    showPartnerWithdrawSuccess(result.amount, result.addr)
                } else {
                    showToastNotify(TOASTR_ERROR, '', result.msg)
                }
            }
        }
    });
}

const showPartnerWithdrawSuccess = (amount, address) => {
    $('#partnerConfirmWithdrawQuery').modal('hide');
    $('#partner-amount-withdraw').text(amount);
    $('#partner-btc-address').text(address);
    $('#partnerWithdrawSuccess').modal('show');
}

const hidePartnerWithdrawSuccess = () => {
    $('#partnerWithdrawSuccess').on('hidden.bs.modal', function (e) {
        window.location.reload();
    })
}

const openPartnerWithdrawModal = () => {
    const withdrawUsdAmount = $('#partner-max-withdraw-amount').text();
    $('#partner-withdraw-amount').text(withdrawUsdAmount);
    $('#partnerWithdraw').modal('show');
}

const changePartnerWithdrawData = () => {
    const usdAmount = $('#partner-withdraw-btc-amount');
    const btcAddress = $('#partner-withdraw-btc-addr');
    const btcAddrError = $('#partner-withdraw-btc-addr-error');
    const usdAmountError = $('#partner-withdraw-btc-amount-error');
    const usdAmountMinError = $('#partner-withdraw-btc-amount-min-error');

    if (btcAddress.hasClass(ERROR_INPUT_DATA)) {
        btcAddress.removeClass(ERROR_INPUT_DATA);
    }
    if (usdAmount.hasClass(ERROR_INPUT_DATA)) {
        usdAmount.removeClass(ERROR_INPUT_DATA);
    }
    if (!btcAddrError.hasClass(NON_VISIBLE)) {
        btcAddrError.addClass(NON_VISIBLE);
    }
    if (!usdAmountError.hasClass(NON_VISIBLE)) {
        usdAmountError.addClass(NON_VISIBLE);
    }
    if (!usdAmountMinError.hasClass(NON_VISIBLE)) {
        usdAmountMinError.addClass(NON_VISIBLE);
    }
}

const changePartnerWithdrawUsdAmount = () => {
    checkSymbols('partner-withdraw-usd-amount');
    const usdAmount = $('#partner-withdraw-usd-amount');
    const btcAddress = $('#partner-withdraw-btc-addr');
    if (btcAddress.hasClass(ERROR_INPUT_DATA)) {
        btcAddress.removeClass(ERROR_INPUT_DATA);
    }
    if (usdAmount.hasClass(ERROR_INPUT_DATA)) {
        usdAmount.removeClass(ERROR_INPUT_DATA);
    }
}

const partnerWithdrawActiveFields = () => {
    $('#partner-withdraw-usd-amount').focusin(function() {
        $('#partner-withdraw-prepend-usd').addClass('info-background');
    });
    $('#partner-withdraw-usd-amount').focusout(function() {
        $('#partner-withdraw-prepend-usd').removeClass('info-background');
    });
}

window.partnerWithdraws = partnerWithdraws;
window.confirmPartnerWithdraw = confirmPartnerWithdraw;
window.openPartnerWithdrawModal = openPartnerWithdrawModal;
window.changePartnerWithdrawUsdAmount = changePartnerWithdrawUsdAmount;
window.changePartnerWithdrawData = changePartnerWithdrawData;

$(document).ready(() => {
    hidePartnerWithdrawSuccess();
    partnerWithdrawActiveFields();
});

